document.addEventListener('DOMContentLoaded', function () {
  const openButtons = document.querySelectorAll('.js-open-nutrition-popup');

  openButtons.forEach(btn => {
    const popupId = btn.dataset.popup;
    const popup = document.getElementById(popupId);

    if (!popup) return;

    const closeBtn = popup.querySelector('.nutrition-popup-close');
    const overlay = popup.querySelector('.nutrition-popup-overlay');

    // Open popup
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      popup.classList.add('is-active');
      document.body.style.overflow = 'hidden';
    });

    // Close popup function
    const closePopup = () => {
      popup.classList.remove('is-active');
      document.body.style.overflow = '';
    };

    // Close popup on close button or overlay
    if (closeBtn) closeBtn.addEventListener('click', closePopup);
    if (overlay) overlay.addEventListener('click', closePopup);

    // Optional: close on ESC key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && popup.classList.contains('is-active')) {
        closePopup();
      }
    });
  });
});
